import * as actions from "./actions";
import mutations from "./mutations";
import * as getters from "./getters";
import state from "./state";

export default {
  namespaced: true,
  state: Object.assign({}, state),
  actions,
  mutations,
  getters
};
